import type { Application } from "express";

export interface TaskQueueLike {
  name: string;
  initialize: (name: string, app: Application) => Promise<void>;
  startWork: () => Promise<void>;
  shutdown: () => Promise<void>;
  readonly canary: any;
  /**
   * @deprecated This is an old method leaked from Bull APIs
   */
  clean?: (status?: any) => Promise<void>;
}
